<dl *ngFor="let item of productInfo | keyvalue" class="col-xs-6 hoverme">
    <dt class="truncate" title="{{item.key}}">{{item.key}}</dt>
        <ul *ngIf="item.value.links" class="link-list">
            <li *ngFor="let link of item.value.links"><a href="{{link.href}}" target="_blank" (click)="displayLinkMsg(link.href)"> {{link.name}} </a></li>
        </ul>
        <dd *ngIf="!item.value.links && searchableMetadataFields.includes(item.value.name)">
            <a *ngIf="item.value.isValidCollection" 
               class="pointMe" 
               (click)="resultFieldSearch(item.value.name, item.value.cleanedValue)" 
               [title]="item.value.cleanedValue">
              {{ item.value.cleanedValue }}
            </a> 
            <p *ngIf="!item.value.isValidCollection"
                class='dd-text-collapse'
                ddTextCollapse
                [ddTextCollapseMaxLength]="item.value.maxLength" 
                [ddTextCollapseText]="item.value.cleanedValue">
            </p>
        </dd>                                  
        <span *ngIf="!item.value.links && !searchableMetadataFields.includes(item.value.name)"
           class='dd-text-collapse'
           ddTextCollapse
           [ddTextCollapseMaxLength]="item.value.maxLength" 
           [ddTextCollapseText]="item.value.value">
        </span>
</dl>